<template>
  <b-select
    v-model="$i18n.locale"
    :options="langOptions"
    name="langSelector"
    title="language"
    size="sm"
    @change="handleChangeLanguage"
  ></b-select>
</template>

<script>
import { availableLanguages } from "../config/languages/i18n";

export default {
  name: "SelectLanguage",
  methods: {
    handleChangeLanguage(newValue) {
      localStorage.setItem("lang", newValue);
    }
  },
  computed: {
    langOptions() {
      let languages = [];
      for (let key in availableLanguages) {
        languages.push({ value: key, text: availableLanguages[key] });
      }
      return languages;
    }
  }
};
</script>

<style lang="scss" scoped>
select {
  display: none;
}

option {
  padding: 5px 10px;
}
</style>
